<template>
  <div>
    <div class="page-sidebar" id="main-menu">
      <div
        class="page-sidebar-wrapper scrollbar-dynamic"
        id="main-menu-wrapper"
      >
        <div class="user-info-wrapper">
          <div class="profile-wrapper">
            <img src="/assets/img/profile.png" alt="" class="logo" />
          </div>
          <div class="user-info">
            <div class="greeting">Welcome</div>
            <div class="username">
              {{ $auth.user().first_name }}
              <span class="bold">{{ $auth.user().last_name }}</span>
            </div>
          </div>
        </div>
        <ul class="all-menu">
          <template v-for="(sidebar, index) in sidebars">
            <template v-if="
              !(
                (sidebar.title === 'Fabrics' || sidebar.title === 'Books')
                && !( $Fabric.isFabricSystemUser($auth.user()) || $Fabric.isFabricInventoryUser($auth.user()))
                ||
                (sidebar.title === 'Emails' && $auth.user().role !== 'admin')
              )
            ">
              <!-- menu with sub -->
              <li
                class="bef:top-level-menu"
                v-if="sidebar.sub"
                :class="subIsActive(sidebar.link, 'open')"
                :key="index"
              >
                <a href="javascript:;">
                  <span class="nav-badge" v-if="sidebar.badge != null">
                    <b class="badge badge-sm badge-pill badge-section-total">{{
                      sidebar.badge.total
                    }}</b>
                  </span>
                  <i :class="'fa fa-' + sidebar.icon"></i>
                  <span class="title">{{ sidebar.title }}</span>
                  <span class="arrow"></span>
                </a>

                <ul class="sub-menu">
                  <li
                    class="sub-menu-items bef:sub-menu"
                    v-for="(sub, subIndex) in sidebar.sub"
                    :key="subIndex"
                  >
                    <span class="nav-badge-sub" v-if="sub.badge != null">
                      <b class="badge badge-sm badge-pill badge-total">
                        <span v-if="sub.badge.total > 0">{{
                          sub.badge.total
                        }}</span>
                      </b>
                      <b class="badge badge-sm badge-pill badge-not-moved">
                        <span v-if="sub.badge.notMoving > 0">{{
                          sub.badge.notMoving
                        }}</span>
                      </b>
                    </span>

                    <!-- if sub menu has its sub menu -->
                    <a href="javascript:void(0)" v-if="sub.sub">
                      {{ sub.title }}
                      <span v-if="sub.sub" class="arrow"></span>
                    </a>
                    <ul class="sub-of-sub sub-menu" v-if="sub.sub">
                      <li
                        class="bef:sub-sub-menu"
                        v-for="(subOfSub, sub_index) in sub.sub"
                        :key="sub_index"
                      >
                        <router-link
                          :class="
                            subOfSub.link
                              ? subIsActive(subOfSub.link, 'active')
                              : ''
                          "
                          :to="{ path: subOfSub.link }"
                        >
                          {{ subOfSub.title }}
                        </router-link>
                        <span
                          class="nav-badge-sub-of-sub"
                          v-if="subOfSub.badge != null"
                        >
                          <b class="badge badge-sm badge-pill badge-total">{{
                            subOfSub.badge.total
                          }}</b>
                          <b
                            class="badge badge-sm badge-pill badge-not-moved"
                            v-if="subOfSub.badge.notMoving > 0"
                            >{{ subOfSub.badge.notMoving }}</b
                          >
                        </span>
                      </li>
                    </ul>

                    <!-- if sub menu has no sub menu -->
                    <router-link v-if="!sub.sub" :to="sub.link">
                      <i
                        class="fa fa-circle-o sub-menu-circle-icon"
                        aria-hidden="true"
                        v-if="sub.showCircleIcon"
                      ></i>
                      {{ sub.title }}
                    </router-link>
                  </li>
                </ul>
              </li>
              <!-- single menu without sub -->
              <li v-else :key="index">
                <!-- different layout for accessories_orders menu -->
                <router-link :to="sidebar.link" v-if="sidebar.keyword === 'accessories_orders'">
                  <span class="nav-badge accessories-order-menu" v-if="sidebar.badge.total != 0">
                    <b class="badge badge-sm badge-pill badge-not-moved">{{
                      sidebar.badge.total
                    }}</b>
                  </span>
                  <i :class="'fa fa-' + sidebar.icon"></i>
                  <span class="title">{{ sidebar.title }}</span>
                  <span class="selected"></span>
                </router-link>

                <!-- for other menus -->
                <router-link :to="sidebar.link" v-else>
                  <span class="nav-badge" v-if="sidebar.badge != null">
                    <b class="badge badge-sm badge-pill badge-section-total">{{
                      sidebar.badge.total
                    }}</b>
                    <b
                      v-if="sidebar.badge.notMoving !== 0"
                      class="badge badge-sm badge-pill badge-not-moved"
                      >{{ sidebar.badge.notMoving }}</b
                    >
                  </span>
                  <i :class="'fa fa-' + sidebar.icon"></i>
                  <span class="title">{{ sidebar.title }}</span>
                  <span class="selected"></span>
                </router-link>
              </li>

            </template>
          </template>
        </ul>
      </div>
    </div>
    <div class="footer-widget">
      <div class="text-center">
        <span
          @click.prevent="
            $auth.logout({ redirect: '/login', makeRequest: true })
          "
        >
          Logout
          <a href=""><i class="fa fa-power-off"></i></a>
        </span>
        <span class="float-right">
          <i
            @click="setShirtOrderRefreshInterval()"
            class="fa fa-gear text-white"
            aria-hidden="true"
          ></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import sidebars from "./config/sidebars.js";
export default {
  data() {
    return {
      sidebars,
      intervalTime: null,
    };
  },
  mounted() {
    this.getPageData();
    this.getBookCategories();
    this.runGetPageDataInterval();
  },
  methods: {
    runGetPageDataInterval() {
      let refreshInterval = window.localStorage.getItem("refresh-interval");
      let seconds = 1000 * 60 * (refreshInterval ? refreshInterval : 1);
      this.intervalTime = setInterval(() => {
        this.getPageData();
      }, seconds);
    },

    async getBookCategories() {
      let results = await axios.get("/v2/fabrics/book-category");
      let allBookCategories = results.data.data.collection;

      let bookMenuIndex = 1;
      this.sidebars[bookMenuIndex].sub = [];

      allBookCategories.forEach((category) => {
        if (!category.parent_fabric_book_category_id) {
          let subCategories = allBookCategories.filter((c) => {
            return c.parent_fabric_book_category_id == category.id;
          });

          if (subCategories.length > 0) {
            let subMenu = [
              { title: category.title, link: "/book/list/" + category.id },
            ];
            subCategories.forEach((subCategory) => {
              subMenu.push({
                title: subCategory.title,
                link: "/book/list/" + subCategory.id,
              });
            });
            this.sidebars[bookMenuIndex].sub.push({
              title: category.title,
              link: "/book/list/" + category.id,
              sub: subMenu,
            });
          } else {
            this.sidebars[bookMenuIndex].sub.push({
              title: category.title,
              link: "/book/list/" + category.id,
            });
          }
        }
      });
    },

    async getPageData() {
      try {
        let res = await axios.get("/shirt_orders/back_log_for_sidebar");
        this.setBadgeNumberInSideberForShirt(res.data.shirt_orders);
        this.setBadgeNumberInSideberForTime(res.data.shirt_orders);
        this.setBadgeNumberInSideberForAccessoriesOrders(res.data.accessories_orders);
      } catch (err) {
        console.log(err);
      }
    },

    setBadgeNumberInSideberForShirt(result) {
      let self = this;
      Object.keys(result).forEach(function (key) {
        /** find index from sidebars with return result eg - new_orders */
        let index = self.sidebars.findIndex((sidebar) => {
          return sidebar.keyword == key;
        });
        if (index != -1) {
          /** set badge value from total */
          self.sidebars[index].badge = {
            total: result[key].total,
            notMoving: result[key].totalNotMovingShirts,
          };
          /** get stations list*/
          let stations = result[key].stations;
          /** if there is stations loop all station and set badge value*/
          if (result[key].stations) {
            Object.keys(stations).forEach(function (stationKey) {
              /** get station index key from sidebar */
              let stationIndexFromSidebar = self.sidebars[index].sub.findIndex(
                (sub) => {
                  return sub.keyword == stationKey;
                }
              );
              if (stationIndexFromSidebar != -1) {
                /** set sub sidebar (station) badge value */
                let notMovingBadge = stations[stationKey].totalNotMovingShirts
                  ? stations[stationKey].totalNotMovingShirts
                  : 0;

                self.sidebars[index].sub[stationIndexFromSidebar].badge = {
                  total: stations[stationKey].total,
                  notMoving: notMovingBadge,
                };
              }
            });
          }
        }
      });
    },

    setBadgeNumberInSideberForCurly(result) {
      let self = this;
      let index = self.sidebars.findIndex((sidebar) => {
        return sidebar.keyword == "curly";
      });

      let overviewIndex = self.sidebars[index].sub.findIndex((sidebar) => {
        return sidebar.keyword == "curly_overview";
      });

      Object.keys(result).forEach(function (key) {
        let subIndex = self.sidebars[index].sub[overviewIndex].sub.findIndex(
          (subClurySection) => {
            return subClurySection.keyword == key;
          }
        );

        let clurySubSection =
          self.sidebars[index].sub[overviewIndex].sub[subIndex];
        clurySubSection.badge = {
          total: result[key].total,
          notMoving: result[key].notMoving,
        };
      });
    },

    setBadgeNumberInSideberForKellerfaltenbluse(result) {
      let self = this;
      let index = self.sidebars.findIndex((sidebar) => {
        return sidebar.keyword == "kfb";
      });

      let overviewIndex = self.sidebars[index].sub.findIndex((sidebar) => {
        return sidebar.keyword == "kfb_overview";
      });

      Object.keys(result).forEach(function (key) {
        let subIndex = self.sidebars[index].sub[overviewIndex].sub.findIndex(
          (subKellerfaltenbluseSection) => {
            return subKellerfaltenbluseSection.keyword == key;
          }
        );

        let kellerfaltenbluseSubSection =
          self.sidebars[index].sub[overviewIndex].sub[subIndex];
        kellerfaltenbluseSubSection.badge = {
          total: result[key].total,
          notMoving: result[key].notMoving,
        };
      });
    },

    setBadgeNumberInSideberForTime(result) {
      let self = this;
      let index = self.sidebars.findIndex((sidebar) => {
        return sidebar.keyword == "time";
      });
      self.sidebars[index].badge = {
        total: result.time.max_age,
        notMoving: result.time.age_of_30th,
      };
    },

    setBadgeNumberInSideberForAccessoriesOrders(result) {
      let self = this;
      let index = self.sidebars.findIndex((sidebar) => {
        return sidebar.keyword == "accessories_orders";
      });
      self.sidebars[index].badge = {
        total: result.total,
      };
    },

    async setShirtOrderRefreshInterval() {
      let refreshInterval = window.localStorage.getItem("refresh-interval");
      const { value: minute } = await Swal.fire({
        title: "Shirt Order Refresh Interval (minute)",
        input: "number",
        inputValue: refreshInterval ? refreshInterval : 1,
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value || !Number(value) || value < 1) {
            return "Invalid Number";
          }
        },
      });

      if (minute) {
        window.localStorage.setItem("refresh-interval", minute);
        clearInterval(this.intervalTime);
        this.runGetPageDataInterval();
      }
    },

    subIsActive(input, className = "active") {
      const paths = Array.isArray(input) ? input : [input];
      let res = paths.some((path) => {
        // current path starts with this path string
        return this.$route.path.indexOf(path) === 0;
      });
      if (res) {
        return className;
      }
    },
  },
};
</script>

<style scoped lang="scss">
$active-color: #0aa699;
.open > a {
  background: black !important;
  font-weight: bold !important;
}
.sub-menu > li > a.active {
  color: $active-color !important;
  font-weight: bold !important;
}
.all-menu li a.active {
  background: black !important;
  font-weight: bold !important;
  color: white !important;
}
.sub-of-sub.sub-menu li a.active {
  background: transparent !important;
  color: $active-color !important;
  margin-left: 50px !important;
}
.sub-of-sub.sub-menu li a {
  margin-left: 50px !important;
}
.nav-badge {
  right: 53px;
  font-style: normal;
  z-index: 1;
  position: absolute;
  margin-top: -1px;
}
.nav-badge.accessories-order-menu {
  right: 30px;
  font-style: normal;
  z-index: 1;
  position: absolute;
  margin-top: -1px;
}
.nav-badge-sub {
  right: 14px;
  font-style: normal;
  z-index: 1;
  position: absolute;
  margin-top: 4px;
}
.nav-badge-sub-of-sub {
  right: 14px;
  font-style: normal;
  z-index: 1;
  position: absolute;
  margin-top: -25px;
}

b.badge-total,
b.badge-section-total {
  background: transparent;
  color: white;
}

b.badge-not-moved {
  background: red;
  color: white;
}

.page-sidebar .sub-menu-items .arrow:before {
  margin-left: -30px !important;
  margin-right: 0px !important;
  float: left !important;
}
.page-sidebar .page-sidebar-wrapper > ul > li > ul.sub-menu > li.active > a,
.page-sidebar .page-sidebar-wrapper > ul > li > ul.sub-menu > li > a:hover {
  color: $active-color !important;
  font-weight: bold !important;
}
.username {
  font-size: 13px !important;
}
.logo {
  width: 50px;
  border-radius: 250px;
}
.user-info-wrapper .profile-wrapper {
  height: 74px;
  width: auto;
  border-radius: 500px;
  overflow: hidden;
  display: inline-block;
  margin-left: -27px;
  margin-right: 0px;
  margin-top: -7px;
  float: left;
}
.page-sidebar .page-sidebar-wrapper > ul {
  margin-top: 20px !important;
}

.sub-menu-circle-icon {
  left: 18px;
  position: absolute;
  margin-top: 4px;
}
.footer-widget {
  z-index: 99;
  color: white;
  cursor: pointer;
}
/* width */
::-webkit-scrollbar {
  width: 8px;
}
/* Track */
::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #6e6f70 !important;
}
/* Handle */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: black;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: black;
}
</style>
